
import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ContactForm from "@/components/contact/ContactForm";
import { Container } from "@/components/ui/container";

const ContactPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <Container className="py-12">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-3xl font-bold mb-8 text-reagent-blue">Contact Us</h1>
            <p className="text-gray-600 mb-8">
              Have questions about LabSwapp? Fill out the form below and we'll get back to you as soon as possible.
            </p>
            <ContactForm />
          </div>
        </Container>
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
